/**
 * Ordered menu help-anchors a guided nav step walks the user through to reach a
 * route, parent-first. A route like `/foreman-crews/employee-dispatch-page` maps
 * to `['sparta-foreman-crews', 'sparta-employee-dispatch-page']` — the player
 * spotlights the parent category ("Labor") to expand, then the child page to
 * click. Each segment is prefixed with the app slug so the anchors match what
 * the sidebar menu renders (`<appSlug>-<segment>`), keeping the guide in lockstep
 * with the nav instrumentation and unique across apps.
 *
 * Pure so the route->anchors mapping is unit tested without a DOM or router.
 */
export function navHopsForRoute(
  appSlug: string | null | undefined,
  route: string | null | undefined
): string[] {
  const slug = (appSlug || 'app').toString().trim().toLowerCase();
  const segments = (route ?? '')
    .split('?')[0]
    .split('#')[0]
    .split('/')
    .filter(Boolean);
  return segments.map((seg) => `${slug}-${seg.toLowerCase()}`);
}
